import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class guiaTransportistaService {
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarEstado() {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/estado`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarIndicadorSunat() {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/indicador-sunat`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }


    async importarPorId(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/importar?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    
    async importarRegistrados(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/importar-registrados?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket50(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async xml(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/xml?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cdr(filter) {
        const response = await axios
            .get(`${ERP}logistica/guia-transportista/cdr?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/guia-transportista`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-transportista`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async emitir(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-transportista/emitir`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-transportista/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}logistica/guia-transportista/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new guiaTransportistaService();